import React from 'react';
import Hero from './Hero';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import Universe from './Universe';


function ProductPage() {
    return ( 
        <>
         <Hero/>
         <LeftSection 
          imageURL="media/image/kite.png" 
          prodName="Kite"
          prodDesc="Our ultra-fast flagship trading platform with streaming market data, advanced charts, an elegant UI, and more. Enjoy the Kite experience seamlessly on your Android and iOS devices." 
          tryDemo="" 
          learnMore="" 
          googlePlay="" 
          appStore=""/>
         
         <RightSection 
          rgTitle="Console"
          prodDesc="The central dashboard for your Zerodha account. Gain insights into your trades and investments with in-depth reports and visualisations."
          link1="Learn more"
          imgURL="media/image/console.png"/>
         
         <LeftSection 
          imageURL="media/image/coin.png" 
          prodName="Coin"
          prodDesc="Buy direct mutual funds online, commission-free, delivered directly to your Demat account. Enjoy the investment experience on your Android and iOS devices." 
          tryDemo="" 
          learnMore="" 
          googlePlay="" 
          appStore=""/> 

          <RightSection 
          rgTitle="Kite Connect API"
          prodDesc="Build powerful trading platforms and experiences with our super simple HTTP/JSON APIs. If you are a startup, build your investment app and showcase it to our clientbase."
          link1="Kite connect"
          imgURL="media/image/kiteconnect.png"
         />


          <LeftSection 
          imageURL="media/image/varsity.png" 
          prodName="Varsity mobile"
          prodDesc="An easy to grasp, collection of stock market lessons with in-depth coverage and illustrations. Content is broken down into bite-size cards to help you learn on the go." 
          tryDemo="" 
          learnMore="" 
          googlePlay="" 
          appStore=""/>


         <Universe/>
        </>
    );
}

export default ProductPage;